<template lang="pug">
.ShogiBoard
  //- .columns.is-centered.is-mobile
  //-   .ShogiPlayerHeader {{ header }}
  .columns.is-centered.is-mobile
    .ShogiPlayerContainer
        ShogiPlayer(
        sp_summary="is_summary_off"
        sp_layout="is_horizontal"
        :sp_turn.sync="sp_turn"
        sp_overlay_nav="is_overlay_nav_on"
        sp_run_mode= "view_mode"
        :sp_pi_variant= "sp_pi_variant"
        :sp_bg_variant= "sp_bg_variant"
        :sp_player_info= "sp_player_info"
        :sp_body.sync= "sp_body"
        :sp_run_mode.sync="sp_run_mode"
        :sp_viewpoint.sync="sp_viewpoint"
        :sp_hidden_if_piece_stand_blank="sp_hidden_if_piece_stand_blank"
        /*@update:edit_mode_snapshot_sfen="            e => trigger_check('edit_mode_snapshot_sfen', e)"
        @update:play_mode_advanced_full_moves_sfen=" e => trigger_check('play_mode_advanced_full_moves_sfen', e)"
        @update:mediator_snapshot_sfen=" e => trigger_check('mediator_snapshot_sfen', e)"*/
        @update:turn_offset=" e => trigger_check('turn_offset', e)"
        
    )

</template>

<script>
import Vue from 'vue'
import { RunModeInfo } from '../node_modules/shogi-player/components/models/run_mode_info.js'
// Buefy
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
Vue.use(Buefy)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 本体
import ShogiPlayer from 'shogi-player/components/ShogiPlayer.vue'

// function createHeader(ki2, turn) {
//   console.log(ki2, turn)
//   let header = ''
//   let ki2List = []
//   if (ki2 !== '' && ki2 !== undefined) {
//     ki2List = ki2
//       .split(/(?=(▲|△))/g)
//       .filter((item, index) => index % 2 === 0)
//     console.log(ki2List)

//     let index = Number(turn) - 1
//     console.log(ki2List[index])
//     if (0 <= index && index < ki2List.length) {
//       const current = ki2List[index]
//       header =
//                 '【図は' +
//                 current.replace(/▲/g, '☗').replace(/△/g, '☖') +
//                 'まで】'
//     }
//   }
//   return header
// }

export default {
  name: 'HelloWorld'.replace(/\r\n/g, '¥n').replace(/(\n|\r)/g, '¥n'),
  components: {
    ShogiPlayer,
  },
  props: {
    kif: {
      type: String,
      required: false,
      default: '',
    },
    turn: {
      type: String,
      required: false,
      default: '-1',
    },
    ki2: {
      type: String,
      required: false,
      default: '',
    },
    black: {
      type: String,
      required: false,
      default: '先手',
    },
    white: {
      type: String,
      required: false,
      default: '後手',
    },
    board: {
      type: String,
      required: false,
      default: 'wood',
    },
    viewpoint: {
      type: String,
      required: false,
      default: 'black',
    },
  },
  data() {
    return {
      RunModeInfo,

      sp_run_mode: 'view_mode',
      sp_turn: Number(this.turn),
      sp_body: this.kif,
      edit_mode_snapshot_sfen: null,
      play_mode_advanced_full_moves_sfen: null,
      mediator_snapshot_sfen: null,
      turn_offset: null,
      file: { name: null },
      sp_pi_variant:
                this.board === 'paper' ? 'is_pi_variant_b' : 'is_pi_variant_d',
      sp_bg_variant:
                this.board === 'paper'
                  ? 'is_bg_variant_none'
                  : 'is_bg_variant_b',
      sp_player_info: {
        black: { name: this.black },
        white: { name: this.white },
      },
      sp_viewpoint: this.viewpoint,
      sp_hidden_if_piece_stand_blank: false,
      ki2Text: this.ki2,
      // header: createHeader(this.ki2, Number(this.turn)),
      header: '',
    }
  },
  computed: {},
  methods: {
    trigger_check(key, v) {
      this.$data[key] = v
      // this.$data['header'] = createHeader(this.$data.ki2Text, v)
      this.$data['header'] = ''
    },
  },
}
</script>
<style lang="sass">
// ShogiPlayer のスタイル
$sp_assets_dir: "../node_modules/shogi-player/assets"

// Buefyのスタイルをカスタマイズ
@import 'assets/style.scss'

@import "../node_modules/shogi-player/components/ShogiPlayer.sass"
@import url("https://cdn.jsdelivr.net/npm/bulma@0.8.0/css/bulma.css")
@import url("https://cdn.jsdelivr.net/npm/@mdi/font@5.x/css/materialdesignicons.min.css")
@import url("https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@500&display=swap")

@media screen and (max-width: 768px)
  .ShogiPlayerGround.is_mobile_vertical_on .ShogiPlayerBody
       flex-direction: row !important
  .ShogiPlayerGround.is_mobile_vertical_on .Membership.is_position_south
      flex-direction: column !important
      align-self: flex-end !important
  .ShogiPlayerGround.is_mobile_vertical_on .Membership.is_position_north
      flex-direction: column-reverse !important
  .ShogiPlayerGround .Membership
    display: flex !important
    align-items: center !important
  .ShogiPlayerGround.is_mobile_vertical_on .Membership
    width: auto !important
  .ShogiPlayerGround.is_mobile_vertical_on .MembershipLocationPlayerInfo
    line-height: 100% !important
  .ShogiPlayerGround.is_mobile_vertical_on .NavigateBlock
    margin-top: 12px !important
  .ShogiPlayerGround.is_mobile_vertical_on .is_position_south .MembershipStand2
    flex-direction: column !important
  .ShogiPlayerGround.is_mobile_vertical_on .is_position_north .MembershipStand2
    flex-direction: column-reverse !important

.section
  max-width: 700px
  // background-color: cornsilk

.ShogiPlayerHeader
  height: 30px
  font-family: 'Noto Serif JP', serif
  font-weight: bold !important

.ShogiPlayerGround .AspectRatioFixedBlockWrap
  padding: 0px 3px !important
.ShogiPlayerGround .NavigateBlockInside
  width: calc(var(--sp_controller_width_mobile) * 100%)

.ShogiPlayerGround.is_balloon_on .MembershipLocationPlayerInfo
  font-family: 'Noto Serif JP', serif
  padding: 0em
  padding-bottom: 1em
  // background-color: cornsilk

.ShogiPlayerGround.is_mobile_vertical_on .Membership.is_position_south .PieceCount
  top: 5px !important
  bottom: unset !important
  right: unset !important
  left: var(--sp_piece_count_gap_right) !important

.MembershipLocationPlayerInfoName
    writing-mode: vertical-rl

.flex
    display: flex
.ShogiPlayerContainer
    --sp_piece_origin_color: rgba(0, 0, 0, 0.1)

.ShogiPlayerGround .ShogiPlayerWidth
   --sp_body_width: 100%

.ShogiPlayerGround .MembershipLocationPlayerInfo
    font-size: 1rem !important
    font-weight: bold !important
// ShogiPlayer は常に横100%まで広がるので外側で大きさを調整する

.ShogiPlayerContainer
  margin-left: -10px
  width: 95%
  --sp_board_color: hsla(0,0%,100%,1)
  --sp_stand_piece_h: 25px
  --sp_stand_piece_w: 30px
  --sp_piece_count_font_size: 1rem
  --sp_location_mark_inactive_rate: 1
  --se_ws_color: hsla(100,41.18%,80%,1)
  --se_ws_image: none
  --se_ws_blur: 0
  --se_ws_grayscale: 0
  --se_ws_contrast: 1
  --se_ws_invert: 0
  --se_ws_hue: 0
  --se_ws_saturate: 1
  --se_ws_brightness: 1
  --se_ws_sepia: 0

  // 盤テクスチャ
  --sp_board_image: none
  --sp_board_blur: 0
  --sp_board_grayscale: 0
  --sp_board_contrast: 1
  --sp_board_invert: 0
  --sp_board_opacity: 1
  --sp_board_hue: 0
  --sp_board_saturate: 1
  --sp_board_brightness: 1
  --sp_board_sepia: 0
  --sp_board_blend: normal

  // 盤
  --sp_board_padding: 1.5
  --sp_board_radius: 5
  --sp_board_aspect_ratio: 1.097
  --sp_board_piece_rate: 80%
  --sp_board_piece_position: center

  // 盤グリッド
  --sp_grid_color: hsla(0,0%,0%,0.5)
  --sp_grid_outer_color: hsla(0,0%,0%,0.5)
  --sp_grid_stroke: 1
  --sp_grid_outer_stroke: 0
  --sp_grid_star_size: 10%

  // 駒
  --sp_piece_blur: 0
  --sp_piece_grayscale: 0
  --sp_piece_contrast: 1
  --sp_piece_invert: 0
  --sp_piece_opacity: 1
  --sp_piece_hue: 0
  --sp_piece_saturate: 1
  --sp_piece_brightness: 1
  --sp_piece_sepia: 0
  --sp_piece_blend: normal

  // 駒数
  --sp_piece_count_gap_right: 62%
  --sp_piece_count_gap_bottom: 47%
  --sp_piece_count_font_color: hsla(0,0%,0%,0.75)
  --sp_piece_count_bg_color: hsla(0,0%,100%,0.75)
  --sp_piece_count_padding: 2px

  // 駒台
  --sp_stand_piece_rate: 80%
  --sp_stand_hover_border_color: hsla(0,0%,0%,0.2)
  --sp_stand_bg_color: hsla(0,0%,0%,0)

  // 駒箱
  --sp_piece_box_piece_w: 38px
  --sp_piece_box_piece_h: 46px
  --sp_piece_box_piece_rate: 90%
  --sp_piece_box_color: hsla(0,0%,0%,0.2)

  // 影
  --sp_shadow_offset: 2
  --sp_shadow_blur: 3
  --sp_shadow_color: hsla(0,0%,0%,0.4)

  // 成り不成り選択
  --sp_promote_select_modal_bg_color: hsla(0,0%,0%,0.85)
  --sp_promote_select_modal_hover_color: hsla(0,0%,100%,0.5)

  // 駒を操作中の移動元スタイル
  --sp_lifted_origin_bg_color_desktop: hsla(0,0%,0%,0.1)
  --sp_lifted_origin_opacity_desktop: 0

  // 駒台横配置のときの盤の上下の隙間
  --sp_common_gap: 12px

  // 将棋盤全体の外側の横幅(コンテナ幅)
  --se_frame_width: 80vmin

  // コントローラー
  --sp_controller_width: 0.5
  --sp_controller_width_mobile: 0.8

  // Transform 背景
  --se_tf0_perspective: 200px
  --se_tf0_translate_x: 0px
  --se_tf0_translate_y: 0px
  --se_tf0_translate_z: 0px
  --se_tf0_rotate_x: 0.03turn
  --se_tf0_rotate_y: 0turn
  --se_tf0_rotate_z: 0turn
  --se_tf0_scale: 1

  // Transform 盤
  --se_tf1_perspective: 200px
  --se_tf1_translate_x: 0px
  --se_tf1_translate_y: -55px
  --se_tf1_translate_z: 0px
  --se_tf1_rotate_x: 0.015turn
  --se_tf1_rotate_y: 0turn
  --se_tf1_rotate_z: 0turn
  --se_tf1_scale: 1

  // Transform 駒
  --se_tf2_perspective: 200px
  --se_tf2_translate_x: 0px
  --se_tf2_translate_y: 0px
  --se_tf2_translate_z: 0px
  --se_tf2_rotate_x: 0turn
  --se_tf2_rotate_y: 0turn
  --se_tf2_rotate_z: 0turn
  --se_tf2_scale: 1

  --sp_invisible_dimension: 9
</style>
